module.exports = __webpack_public_path__ + "img/tr-car-icon.b4d99db1.svg";